import { render } from "./Modulo.vue?vue&type=template&id=10079f8a&scoped=true"
import script from "./Modulo.vue?vue&type=script&lang=js"
export * from "./Modulo.vue?vue&type=script&lang=js"

import "./Modulo.vue?vue&type=style&index=0&id=10079f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10079f8a"]])

export default __exports__